var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btns",style:({justifyContent: _vm.align?_vm.align:'center'})},[_c('CancelBtn',{on:{"click":function($event){return _vm.$emit('cancel')}}}),_c('SaveBtn',{attrs:{"text":_vm.save},on:{"click":function($event){return _vm.$emit('save')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }